import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import Tabs from '../../../components/Tabs';
import Title from '../../../components/Title';
import AppTable from '../../../components/publisher/AppTable';
import General from '../../../components/publisher/admin/General';
import Version from '../../../components/publisher/admin/Version';
import { Button } from 'react-bootstrap';
import Icon from '../../../components/Icon';
import { useGetPublisherAdminQuery } from '../../../api/publisherAdminApiSlice';

const Admin = () => {
  const publisherId = useParams()["publisherId"];
  const history = useHistory();
	const { t } = useTranslation();
  const { data: publisher={}, isSuccess, isError, retry } = useGetPublisherAdminQuery(publisherId)

  const handleEditClick = () => history.push(`/publishers/${publisher.slug}/admin/edit`);

  if( !isSuccess ) {
    return (<></>)
  }

  return(<>
    <Title main={publisher.name} sub={t('publisher.admin')} group={true} onBack={()=>(history.push(`/publishers/${publisherId}`))}>
      <Button onClick={handleEditClick}>
        <Icon icon='plus' text={t("edit")} />
      </Button>
    </Title>
    <Tabs active={"publisher.general"}>
      <General icon={"home"} as={"publisher.general"} publisherId={publisherId} publisher={publisher} isSuccess={isSuccess} isError={isError} retry={retry} />
      <Version icon={"version"} as={"version"} publisherId={publisherId}/>
      <AppTable publisherId={publisherId} icon={"mobile"} as={"publisher.apps"}/>
    </Tabs>
  </>)
}

export default Admin
